export enum StyleguideImportSections {
    COLORS = "colorStyles",
    TEXT_STYLES = "textStyles",
    COMPONENTS = "components"
}

export default interface StyleguideImportData {
    total?: number;
    success?: number;
    isSyncFinished?: boolean;
}
